<template>
  <el-dialog v-model="visible" width="85%" align-center class="addUser" draggable :before-close="adduserCancel">
    <template #header>
      <div class="header">
        <h4 v-if="addInfo.type == 1">{{ $t("slack.addFriends") }}</h4>
        <h4 v-if="addInfo.type == 2">{{ $t("slack.adduser") }}</h4>
        <p class="hintText f-center" v-if="addInfo.type == 2">
          <svg data-pe9="true" aria-hidden="true" viewBox="0 0 20 20" class="is-inline"
            style="width: 16px; height: 16px; margin-bottom: -2px; color: #333">
            <path fill="currentColor" fill-rule="evenodd"
              d="M9.984 4.176a1 1 0 0 0-1.968-.352L7.448 7H4a1 1 0 1 0 0 2h3.091l-.803 4.5H3a1 1 0 1 0 0 2h2.93l-.414 2.324a1 1 0 0 0 1.968.352l.478-2.676h2.719l-.415 2.324a1 1 0 1 0 1.968.352l.478-2.676H16a1 1 0 1 0 0-2h-2.93l.803-4.5H17a1 1 0 1 0 0-2h-2.77l.504-2.824a1 1 0 1 0-1.968-.352L12.198 7H9.48l.504-2.824Zm1.054 9.324L11.84 9H9.123l-.804 4.5h2.719Z"
              clip-rule="evenodd" />
          </svg>
          <span style="position: relative; top: 2px; left: 2px">
            {{ addInfo.channel }}
          </span>
        </p>
      </div>
    </template>
    <div class="modal_content">
      <div class="inputBox">
        <el-select v-model="userID" ref="UserSelectRef" :placeholder="$t('slack.SelectUserText')" size="large"
          filterable multiple collapse-tags :loading="selectLoading" :filter-method="filterUsers"
          v-Loadmore="getAllUser1" popper-class="SlackselectUser">
          <el-option v-for="item in allusers" :key="item.user_uid" :label="item.nickname" :value="item.user_uid"
            :disabled="item.disabled">
            <span style="float: left">{{ item.nickname }}</span>
            <el-icon v-if="item.disabled" class="select_icon" style="font-size: 12px">
              <Check />
            </el-icon>
          </el-option>
        </el-select>
        <p  style="color:red;position: absolute;font-size: 12px;" v-if="vaild">{{ $t("slack.SelectUserTip") }}
        </p>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button style="background-color: #fff;border: 1px solid rgb(51, 112, 255);color: #3370ff;" @click="Cancel">{{
          $t("slack.Cancel") }}</el-button>
        <el-button type="primary"
          style="background-color: rgb(51, 112, 255);border: 1px solid rgb(215, 226, 237);color: #fff;"
          :disabled="disabledBtn" @click="Confirm">
          {{ $t("slack.Confirm") }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { HomeStore } from "../index";
import * as $axios from "../api/index";
import { debounce, extend } from "../utils/index.js";
import { Check } from "@element-plus/icons-vue";
import { useDemoStore } from "@/pinia/index.js";
import { ElMessage, ElMessageBox } from "element-plus";
import Dialog from "@/components/Dialog/Dialog.js";
import i18n from "@/assets/lang";
export default {
  data() {
    return {
      userID: [],
      visible: false,
      allusers: [],
      userList: [],
      groupUserList: [],
      Check,
      vaild: false,
      disabledBtn: false,
      selectLoading: false,
      pageNo: 1,
      kw: "",
      IsLoad: true
    };
  },
  computed: {
    isAddUser() {
      return HomeStore().setting.isAddUser;
    },
    addInfo() {
      return HomeStore().setting.addInfo;
    },
    friends() {
      return HomeStore().friends;
    },
    token() {
      return HomeStore().token;
    },
  },
  watch: {
    isAddUser(val) {
      this.visible = val;
      this.userID = "";
      this.vaild = false
      this.IsLoad = true
      this.userList = [];
      if (val) {
        this.kw = ''
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.UserSelectRef.focus();
          }, 200);
        });
        if (this.addInfo.type == 2) {
          $axios
            .groupinfo({
              token: HomeStore().token,
              group_id: HomeStore().setting.dialogueInfo.group_id,
            })
            .then((res) => {
              this.groupUserList = res.data.info;
              this.getAllUser()
            });
        } else {
          this.getAllUser()
        }
      }
    },
  },
  methods: {
    Cancel() {
      HomeStore().setConfig("isAddUser", false);
    },
    //邀请用户加入取消事件
    adduserCancel() {
      if (this.userID.length > 0) {
        ElMessageBox.confirm(i18n.global.t("EDM.ElMessageBoxTxet"), {
          confirmButtonText: i18n.global.t("EDM.OkText"),
          cancelButtonText: i18n.global.t("EDM.CancelText"),
          type: "warning",
        })
          .then(() => {
            HomeStore().setConfig("isAddUser", false);
            this.userID = [];
          })
          .catch(() => { });
      } else {
        HomeStore().setConfig("isAddUser", false);
        this.userID = [];
      }
    },
    //提交事件
    Confirm() {
      if (this.userID.length == 0) {
        this.vaild = true
        return;
      }
      this.disabledBtn = true;
      HomeStore().setConfig("isAddUser", false);
      if (this.addInfo.type == 2) {
        this.userID.map((item) => {
          let data = {
            type: "JoinGroup",
            token: this.token,
            to_uid: item,
            group_id: HomeStore().setting.dialogueInfo.group_id,
            // client_id: HomeStore().client_id,
          };
          console.log(data);
          HomeStore().isError[HomeStore().setting.dialogueInfo.group_id] = "";
          useDemoStore().socket.send(JSON.stringify(data));
        });
        Dialog(i18n.global.t("com.handleSuccess"));
      } else {
        $axios
          .addfriends({
            token: this.token,
            to_id: this.userID,
          })
          .then((res) => {
            HomeStore().TabsType = 0
            Dialog(i18n.global.t("slack.AddFriendTip"));
            res.data.map((item) => {
              HomeStore().isError[item.user_uid] = "";
              item.HeadPhotoUrl = item.profile_photo;
              item.friend_avatar_file_name = item.profile_photo;
              item.receiver_name = item.nickname;
              item.unread = 0;
              item.receiver_id = item.user_uid;
              item.IsAddfriend = true
              HomeStore().friends.unshift(item);
              HomeStore().chatMessageList[item.user_uid] = [];
              HomeStore().isNeedQuery[item.user_uid] = true;
            });
            let val = res.data[res.data.length - 1];
            HomeStore().Chatobject = "Addfriend"
            HomeStore().friendClick(val, HomeStore().friends.length);
          });
      }
    },
    //获取下拉用户
    getAllUser(val) {
      this.selectLoading = true
      $axios.Messageallusers({
        keyword: val,
        pageNo: this.pageNo,
        pageSize: 30
      }).then(res => {
        this.IsLoad = res.data.length < 20 ? false : true
        if (this.addInfo.type == 2) {
          this.userList = this.friends.filter(item => item.isFriend)
          res.data.map((item) => {
            let index = this.userList.findIndex((friend) => {
              return friend.user_uid == item.user_uid;
            });
            if (index == -1) {
              this.userList.push(item);
            }
          });
          this.getUser(this.groupUserList, this.userList);
        } else {
          this.userList = res.data
          let friendList = this.friends.filter(item => item.isFriend)
          this.getUser(friendList, this.userList);
        }
        this.selectLoading = false
      })
    },
    //滚动加载下拉用户
    getAllUser1() {
      if (!this.IsLoad) return
      this.pageNo += 1
      $axios.Messageallusers({
        keyword: this.kw,
        pageNo: this.pageNo,
        pageSize: 30
      }).then(res => {
        this.IsLoad = res.data.length < 20 ? false : true
        res.data.map((item) => {
          let index = this.userList.findIndex((friend) => {
            return friend.user_uid == item.user_uid;
          });
          if (index == -1) {
            this.userList.push(item);
          }
        });
        if (this.addInfo.type == 2) {
          this.getUser(this.groupUserList, this.userList)
        } else {
          let friendList = this.friends.filter(item => item.isFriend)
          this.getUser(friendList, this.userList)
        }
      })
    },
    //获取下拉用户
    getUser(userList, allusers) {
      let Ids = [];
      userList.map((item) => {
        Ids.push(String(item.user_uid));
      });
      allusers.map((item) => {
        if (item.user_uid in HomeStore().isError) {
          if (
            Ids.indexOf(String(item.user_uid)) != -1 &&
            !HomeStore().isError[item.user_uid]
          ) {
            item.disabled = true;
          }
        } else {
          if (Ids.indexOf(String(item.user_uid)) != -1 || item.is_friend) {
            item.disabled = true;
          }
        }
      });
      this.allusers = extend(allusers, true);
    },
    filterUsers: debounce(function (val) {
      this.pageNo = 1
      this.kw = val
      this.getAllUser(val)
    }, 500),
  },
};
</script>
<style lang="less">
.addUser {
  .header {
    h4 {
      font-weight: 700;
    }

    .hintText {
      font-size: 15px;
      color: #333;
      font-weight: 700;
      line-height: 1.38461538;
      margin-top: 4px;
    }
  }

  .el-dialog__headerbtn {
    top: 10px !important;
  }

  .el-dialog__header {
    padding-bottom: 0 !important;
  }

  .el-dialog__body {
    padding: 0px 20px 15px 20px;

    .modal_content {
      .inputBox {
        margin-top: 15px;
        position: relative;

        .el-select {
          width: 100%;
        }
      }
    }
  }
}

.SlackselectUser {
  .select_icon {
    position: absolute;
    right: 20px;
    top: 10px;
    color: #409eff;
  }
}
</style>
